import styled from '@emotion/styled';
import type { Classification } from '@zelos/codegen/apis';
import Image from 'next/image';
import type { ChipStyles } from '../Chip';
import Chip from '../Chip';
import pcce from './pcce.svg';
import pccp from './pccp.svg';
import pcsql from './pcsql.svg';
import { breakpointMedium } from '@/constants/breakpoints';
import { colors } from '@/constants/colors';

const Container = styled.div`
display: grid;
row-gap: 4px;

@media (max-width: ${breakpointMedium}) {
  column-gap: 2px;
  grid-template-columns: 1fr auto;
}
`;

interface ClassficationChipProps extends ChipStyles {
  code?: Classification['code'];
}

const ClassificationChip = ({ code, size, ...chipStyles }: ClassficationChipProps) => {
  const defaultChipStyle = {
    minWidth: '62px',
    padding: '5.5px 12px',
  };

  return (
    <Container>
      {(!code || code === 'PCCP') && (
        <Chip
          size={size || 'wide'}
          backgroundColor={colors.lightPurple}
          {...defaultChipStyle}
          {...chipStyles}
        >
          <Image
            src={pccp}
            width={size === 'small' ? 25 : 31}
            height={size === 'small' ? 8 : 10}
            alt="pccp"
          />
        </Chip>
      )}
      {(!code || code === 'PCCE') && (
        <Chip
          size={size || 'wide'}
          backgroundColor={colors.lightBlue}
          {...defaultChipStyle}
          {...chipStyles}
        >
          <Image
            src={pcce}
            width={size === 'small' ? 25 : 31}
            height={size === 'small' ? 8 : 10}
            alt="pcce"
          />
        </Chip>
      )}
      {(!code || code === 'PCSQL') && (
        <Chip
          size={size || 'wide'}
          backgroundColor={colors.pcsqlBackgroundRed}
          {...defaultChipStyle}
          {...chipStyles}
        >
          <Image
            src={pcsql}
            width={size === 'small' ? 30 : 38}
            height={size === 'small' ? 8 : 10}
            alt="pcsql"
          />
        </Chip>
      )}
    </Container>
  );
};

export default ClassificationChip;
